import { notify } from "cy-fe";
import { z } from "zod";

export const Error = z.object({
  messages: z.array(z.string()),
  code: z.string(),
  details: z.any(),
});
export type Error = z.infer<typeof Error>;

export const ValidationError = z.object({
  errors: z.array(Error),
});
export type ValidationError = z.infer<typeof ValidationError>;

export function notifyError(
  error: any,
  {
    defaultMessage = "Something went wrong, please try again",
  }: { defaultMessage?: string } = {},
) {
  let notified = false;
  if (error?.data?.status === 422) {
    const valError = ValidationError.safeParse(error.data.body);
    if (valError.success) {
      const errors = valError.data.errors;
      const singleErr = errors.find((value) => value.messages.length > 0);
      if (singleErr) {
        notify("Error", singleErr.messages[0], { error });
        notified = true;
      }
    }
  }
  if (!notified) {
    notify("Error", defaultMessage, { error });
  }
}
